import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

function DefaultPending() {
  return (
    <div className="grid min-h-[40vh] place-items-center px-6 py-16 text-sm text-muted-foreground">
      <div className="inline-flex items-center gap-2">
        <span className="h-2 w-2 animate-pulse rounded-full bg-primary" />
        Laddar…
      </div>
    </div>
  );
}

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Data hinner sällan bli inaktuell inom en session — undvik onödiga
        // refetchar vid varje navigering/fönsterfokus.
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: false,
    // Förladdad loader-data får återanvändas i 30s, annars slängs preloaden
    // bort och sidan hämtar om allt vid klick.
    defaultPreloadStaleTime: 30_000,
    defaultPendingMs: 0,
    defaultPendingMinMs: 0,
    defaultPendingComponent: DefaultPending,
    // Förladda routes när användaren hovrar/trycker — snabbare navigering
    defaultPreload: "intent",
  });

  return router;
};
